<script setup lang="ts">

import config from '@/assets/config';
import { CalendarModel } from '@/models/CalendarModel';
import dateFormat from 'dateformat';
import { computed, onMounted, ref } from 'vue';

  const loading = ref(false);
  const calendar = ref<CalendarModel[]>([]);
  const error = ref(null);
  const selectionFilter = ref('');

  const notLoading = computed({
    get: () => !loading.value,
    set: (val) => {
      // when the child updates `visible`, invert and write back to `loading`
      loading.value = !val
    }
  })
  
  function clearCalendar() {
    selectionFilter.value = '';
    loading.value = false;
    error.value = null;
  }

  // Carregar as questões
  function loadCalendar(scopeFilter : string, questionFilter : string | null = null) {
      selectionFilter.value = scopeFilter;
      console.log("loading calendar for " + scopeFilter);
      loading.value = true; // Ativa o spinner antes de qualquer operação

      setTimeout(async () => {
        try {
            var user = localStorage.getItem('user');
            const token = localStorage.getItem('token');
            var url = `${config.backendUrl}api/ControlsEvaluation/calendar/${user}?answered=false`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            var json : CalendarModel[] = await response.json();
            calendar.value = json;
        } catch (err) {
            error.value = err.message;
        } finally {
            loading.value = false; // Desativa o spinner após a conclusão
        }
      }, 0); // Garante que o spinner seja exibido antes de iniciar o carregamento
  }

  onMounted(() => {
    console.log("CalendarWidget onMounted begin");
    loadCalendar('home');
    console.log("CalendarWidget onMounted end");
  });

  defineExpose({
      clearCalendar: clearCalendar,
      loadCalendar: loadCalendar
  });

  function getSelectionFilter() {
    return (calendar.value || []);
  }
 
</script>

<template>
  <h5>Calendário de Obrigações</h5>
  <div>
    <Dialog v-model:visible="loading" modal :closable="false">
      <div class="spinner-container">
        <i class="pi pi-spin pi-spinner spinner"></i>
        <p>Carregando calendário...</p>
      </div>
    </Dialog>
    <div>
      <Accordion v-model:visible="notLoading" :value="Array.from({length: getSelectionFilter().length}, (_, i) => i)" multiple>
        <AccordionPanel v-for="(cal, index) in getSelectionFilter()" :key="dateFormat(cal.date, 'dd/mm/yyyy')" :value="index">
            <AccordionHeader class="m-0">
              <h5 class="m-0">{{ dateFormat(cal.date, 'dd/mm/yyyy') }}</h5>
            </AccordionHeader>

            <AccordionContent v-for="(plan, qIndex) in cal.plannings">

              <ul>
                <li>
                  <table>
                    <tr>
                      <th class="px-5">Título do trabalho</th>
                      <th class="px-5">Quantidade de questões a responder</th>
                    </tr>
                    <tr class="py-2">
                      <td class="py-2 px-5">{{ plan.title }}</td>
                      <td class="py-2 px-5">{{ plan.questionCount }}</td>
                    </tr>
                  </table>
                </li>
              </ul>

            </AccordionContent>

        </AccordionPanel>
      </Accordion>
    </div>
  </div>
</template>

<style>
.spinner-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.spinner {
  font-size: 2rem;
  margin-bottom: 1rem;
}
</style>

